import {createReducers, createActions, request} from '../../../utils/';
import {combineReducers} from 'redux';
import Urls from '../../../../config/index';

const {LogCollectUrl} = Urls;

const path = name => `app/pages/deviceIndex/${name}`;


const models = {

    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },

    // 时间轴信息
    timeLineData: {
        data: [],
        handlers: {
            timeLineList(state, action) {
                return action.payload;
            },
        },
    },

    // filter信息
    filterData: {
        data: [],
        handlers: {
            filterList(state, action) {
                return action.payload;
            },
        },
    },

    // 查询数据
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },

    // 状态
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },

    // 当前选择数据的Uuid
    currentUuid: {
        data: '',
        handlers: {
            changeCurrentUuid(state, action) {
                return action.payload;
            },
        },
    },

};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

/**
 * 列表请求参数
 *
 * @param getState
 * @returns {{pageSize: *, page: *}}
 */
const formatGetParams = getState => {
    const state = getState().logCollect;
    const searchValue = state.searchValues || {};
    const params = {
        ...searchValue
    };
    return params;
};

/**
 * 列表
 *
 * @returns {function(*, *=): Promise<void>}
 */
export const asyncList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            let result = await request(LogCollectUrl.list, 'POST', formatGetParams(getState));
            if (result && result.length > 0) {
                const uuid = result[0].children[0].key;
                dispatch(actions.changeCurrentUuid(uuid));
                let timeLineResult = await request(LogCollectUrl.timeLineList, 'POST', {'uuid': uuid});
                dispatch(actions.timeLineList(timeLineResult));
            } else {
                dispatch(actions.changeCurrentUuid(''));
                dispatch(actions.timeLineList([]));
            }
            dispatch(actions.get(result));
        } catch (e) {
            dispatch(actions.changeCurrentUuid(''));
            dispatch(actions.timeLineList([]));
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}),);
        }
    };
};

/**
 *
 * 查询时间轴
 *
 * @param uuid
 * @returns {function(*, *): Promise<void>}
 */
export const asyncTimeLineList = (uuid) => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({isLoading: true}));
            let result = await request(LogCollectUrl.timeLineList, 'POST', {'uuid': uuid});
            dispatch(actions.timeLineList(result));
        } catch (e) {
            dispatch(actions.timeLineList([]));
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({isLoading: false}));
        }
    };
};





// WEBPACK FOOTER //
// ./pages/assist/logCollect/reducers.js